import { useState, useEffect, useCallback, useRef } from "react";
import { fetchRates, FALLBACK_RATES, type Rate } from "../services/exchangeRateService";

interface UseExchangeRatesReturn {
  rates: Rate[];
  loading: boolean;
  error: string | null;
  lastUpdated: Date | null;
}

export function useExchangeRates(refreshInterval = 60_000): UseExchangeRatesReturn {
  const [rates, setRates] = useState<Rate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const isFirstLoad = useRef(true);

  const load = useCallback(async () => {
    if (isFirstLoad.current) {
      setLoading(true);
    }

    try {
      const data = await fetchRates();
      if (data.length > 0) {
        setRates(data);
        setLastUpdated(new Date());
        setError(null);
      } else {
        throw new Error("Boş veri");
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : "Bilinmeyen hata";
      setError(message);

      if (isFirstLoad.current) {
        setRates(FALLBACK_RATES);
        setLastUpdated(null);
      }
    } finally {
      isFirstLoad.current = false;
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, refreshInterval);
    return () => clearInterval(id);
  }, [load, refreshInterval]);

  return { rates, loading, error, lastUpdated };
}
